module.exports = __webpack_public_path__ + "static/img/avatar-s-4.61de186b.jpg";